import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'delete-document', [
  'UPDATE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
    'documents',
    {
      type: 'payload',
      selector: ['documentId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/delete-document-req.js